// ---------- dessiner une grille case par case, hors du jeu ----------
// La page de partage (share.ts) et la vidéo de remplissage (video.ts) posent les cases une à une,
// dans un ordre mélangé, sur un canevas qu'elles ne réeffacent pas. Un alphabet qui se dessine
// selon ses voisines (Alphabet.prepareFilled, le point de croix) doit alors savoir lesquelles sont
// DÉJÀ posées : sans ça il les croyait toutes brodées, et les premières croix isolées sortaient
// cernées d'un creux sombre au lieu du papier (revue du 2026-10-23 : 2 971 px d'écart avec le jeu
// sur le renard à 30 %). Et une case qui arrive change le voisinage de celles d'à côté, qui se
// redessinent par-dessus — le dessin d'une telle case reste dans sa case. C'est ce que fait le
// jeu pour les siennes (cf. bakeCells dans render.ts).

import type { Alphabet } from '../shared/alphabets/types';

/** Aucune case posée : l'état à passer à `prepareFilled`, que placeCell() tient à jour. */
export function noneStitched(target: readonly (readonly number[])[]): boolean[][] {
  return target.map((row) => row.map(() => false));
}

/** Pose la case (r, c) : la marque comme posée, et rend les cases à dessiner — elle, puis ses
 *  voisines déjà posées quand l'alphabet dépend de son voisinage. Les autres alphabets n'ont
 *  qu'elle à dessiner, comme avant. */
export function placeCell(
  alpha: Alphabet,
  done: boolean[][],
  r: number,
  c: number,
): Array<readonly [number, number]> {
  done[r][c] = true;
  const out: Array<readonly [number, number]> = [[r, c]];
  if (!alpha.prepareFilled) return out;
  for (const [rr, cc] of [
    [r - 1, c],
    [r + 1, c],
    [r, c - 1],
    [r, c + 1],
  ] as const)
    if (done[rr]?.[cc]) out.push([rr, cc]);
  return out;
}
